import * as routesApi from "../../backend/routesApi.js";
import {
  getSettings,
} from "../../backend/settingsApi.js";
import {
  getData,
} from "../../backend/dataEditorApi.js";
import {
  unloadingPlaceTypes,
} from "../../enums/unloading-place-types.js";

const state = {
  route: {},
  state: 0,
  unloadingPlaceChanged: null,
  logist: null,
  customsManager: null,
  forwarder: null,
  vehicle: null,
  driver: null,
  selectedSetting: null,
  columns: [],
  savedSettings: [],
  unloadingPlaces: [],
  defaultWarehouse: null,
  editableRouteInfoItem: null,
  transportInfo: [],
  routeItems: [],
  routeDates: {},
  editableRouteItem: null,
  compactMode: false,
  carrier: null,
  attachments: [],
};
const getters = {
  getRoute(state) {
    return state.route;
  },
  getState(state) {
    return state.state;
  },
  getUnloadingPlaceChanged(state) {
    return state.unloadingPlaceChanged;
  },
  getLogist(state) {
    return state.logist;
  },
  getCustomsManager(state) {
    return state.customsManager;
  },
  getForwarder(state) {
    return state.forwarder;
  },
  getVehicle(state) {
    return state.vehicle;
  },
  getDriver(state) {
    return state.driver;
  },
  selectedSetting(state) {
    return state.selectedSetting;
  },
  columns(state) {
    return state.columns;
  },
  savedSettings(state) {
    return state.savedSettings;
  },
  unloadingPlaces(state) {
    return state.unloadingPlaces;
  },
  defaultWarehouse(state) {
    return state.defaultWarehouse;
  },
  editableRouteInfoItem(state) {
    return state.editableRouteInfoItem;
  },
  transportInfo(state) {
    return state.transportInfo;
  },
  routeItems(state) {
    return state.routeItems;
  },
  routeDates(state) {
    return state.routeDates;
  },
  editableRouteItem(state) {
    return state.editableRouteItem;
  },
  compactMode(state) {
    return state.compactMode;
  },
  getCarrier(state) {
    return state.carrier;
  },
  getAttachments(state) {
    return state.attachments;
  },
};
const actions = {
  async getRouteInfo({
    getters,
    commit,
  }, id) {
    const route = await routesApi.getRoute(id);
    commit("setRoute", route);
    commit("setState", route.state);
    commit("setLogist", route.logist);
    commit("setCustomsManager", route.customsManager);
    commit("setForwarder", route.forwarder);
    commit("setVehicle", route.vehicle);
    commit("setDriver", route.driver);
    commit("setCarrier", route.carrier);
    let unloadingPlaces = [];
    if (route.unloadingPlaces.length !== 0) {
      unloadingPlaces = route.unloadingPlaces.map(place => {
        return {
          id: place.id,
          title: place.unloadingFactory && place.unloadingAddress ?
            `${place.unloadingFactory.title}; ${place.unloadingAddress.title}` : place.unloadingWarehouse && place.unloadingAddress ?
              `${place.unloadingWarehouse.title}; ${place.unloadingAddress.title
              }` :
              !place.unloadingFactory &&
                !place.unloadingWarehouse &&
                place.unloadingAddress ?
                `${place.unloadingAddress.title}` : "",
          type: place.unloadingFactory ? {
            value: unloadingPlaceTypes.FACTORY,
            text: "Склад продавца",
          } : place.unloadingWarehouse && place.unloadingWarehouse.groupedWarehouse ? {
            value: unloadingPlaceTypes.GROUPEDWAREHOUSE,
            text: "Группажный склад",
          } : place.unloadingWarehouse && !place.unloadingWarehouse.groupedWarehouse ? {
            value: unloadingPlaceTypes.OTHERWAREHOUSE,
            text: "Другой склад",
          } : place.unloadingAddress ? {
            value: unloadingPlaceTypes.ADDRESS,
            text: "Другое",
          } : { value: unloadingPlaceTypes.FACTORY, text: "Склад продавца" },
          unloadingCountry: place.unloadingCountry,
          unloadingFactory: place.unloadingFactory,
          unloadingWarehouse: place.unloadingWarehouse,
          unloadingAddress: place.unloadingAddress,
        };
      });
    } else {
      unloadingPlaces.push(getters.defaultWarehouse);
    }
    commit("setUnloadingPlaces", unloadingPlaces);
    commit("setAttachments", route.attachments);
  },
  async getRouteItems({
    commit,
  }, id) {
    const resultData = await routesApi.getRouteItems(id);
    commit("setRouteItems", resultData.items);
    commit("setTransportInfo", resultData.transportInfo);
    commit("setRouteDates", resultData.routeDates);
  },
  async changeState({
    commit,
  }, params) {
    await routesApi.changeState(params.id, params.newState.id);
    commit("setState", params.newState);
  },
  async saveCustomsRegistrationDate({
    dispatch,
  }, params) {
    const date = {
      value: params.date,
    };
    await routesApi.saveCustomsRegistrationDate(params.id, date);
    await dispatch("getRouteInfo", params.id);
  },
  async saveArriveToWarehouseDate({
    dispatch,
  }, params) {
    const date = {
      value: params.date,
    };
    await routesApi.saveArriveToWarehouseDate(params.id, date);
    await dispatch("getRouteInfo", params.id);
  },
  async changeRouteInfoItem({
    getters,
    commit,
  }, params) {
    if (!params.name) {
      return;
    }
    const route = getters.getRoute;
    if (
      (params.element?.id !== route[params.name]?.id) ||
      (params.element !== route[params.name])
    ) {
      const res = await routesApi.changeRouteInfo(
        params.id,
        params.name,
        params.element?.id || params.element,
      );
      if (params.name === "driver") {
        route.driver = res.data ? {
          carrier: res.data.Carrier ? { id: res.data.Carrier.Id, title: res.data.Carrier.Title } : null,
          id: res.data.Id,
          isRemoved: res.data.IsRemoved,
          name: res.data.Name,
          phones: res.data.Phones,
          surname: res.data.Surname,
          title: res.data.Title,
          viber: res.data.Viber,
        } : null;
        commit("setDriver", res.data ? {
          id: res.data.Id,
          title: res.data.Title,
        } : null);
      }
      else {
        const item = params.element ? {
          id: params.element.id,
          title: params.element.title,
        } : null;
        route[params.name] = item;
        const transformedParamName = params.name.split("-").map(i => {
          const item = i.charAt(0).toUpperCase() + i.slice(1);
          return item;
        });
        const mutationName = `set${transformedParamName.join("")}`;
        commit(mutationName, item);
      }
    }
  },
  async saveRoutePrefix({
    getters,
  }) {
    const route = getters.getRoute;
    await routesApi.saveRoutePrefix(route.id, route.routePrefix);
  },
  async getDefaultWarehouse({
    commit,
  }) {
    const warehouse = await getSettings();
    const address = await getData("warehouses", false, warehouse.data.Warehouse.Id);
    commit("setDefaultWarehouse", {
      title: warehouse.data.Warehouse.Title,
      type: {
        value: unloadingPlaceTypes.GROUPEDWAREHOUSE,
        text: "Группажный склад",
      },
      unloadingWarehouse: warehouse.data.Warehouse ? {
        id: warehouse.data.Warehouse.Id,
        title: warehouse.data.Warehouse.Title,
      } : null,
      unloadingAddress: address.data.Address ? {
        id: address.data.Address.Id,
        title: address.data.Address.Title,
      } : null,
    });
  },
  changeRouteItem({ commit, getters }, column) {
    const items = getters.routeItems;
    items.forEach(i => {
      if (i.id === getters.editableRouteItem.id) {
        i[column] = getters.editableRouteItem[column];
      }
    });
    commit("setRouteItems", items);
    if (column !== "inCar" && column !== "unloaded") {
      commit("setEditableRouteItem", null);
    }
  },
};
const mutations = {
  setRoute(state, value) {
    state.route = value;
  },
  setAttachments(state, value) {
    state.attachments = value;
  },
  setState(state, value) {
    state.state = value;
  },
  setUnloadingPlaceChanged(state, params) {
    state.unloadingPlaceChanged = params;
  },
  setLogist(state, value) {
    state.logist = value;
  },
  setCustomsManager(state, value) {
    state.customsManager = value;
  },
  setForwarder(state, value) {
    state.forwarder = value;
  },
  setVehicle(state, value) {
    state.vehicle = value;
  },
  setDriver(state, value) {
    state.driver = value;
  },
  setSelectedSetting(state, selectedSetting) {
    state.selectedSetting = selectedSetting;
  },
  setColumns(state, columns) {
    state.columns = columns;
  },
  setSavedSettings(state, savedSettings) {
    state.savedSettings = savedSettings;
  },
  setUnloadingPlaces(state, value) {
    state.unloadingPlaces = value;
  },
  setDefaultWarehouse(state, value) {
    state.defaultWarehouse = value;
  },
  setEditableRouteInfoItem(state, value) {
    state.editableRouteInfoItem = value;
  },
  setTransportInfo(state, value) {
    state.transportInfo = value;
  },
  setRouteItems(state, value) {
    state.routeItems = value;
  },
  setRouteDates(state, value) {
    state.routeDates = value;
  },
  setEditableRouteItem(state, value) {
    state.editableRouteItem = value;
  },
  setCompactMode(state, value) {
    state.compactMode = value;
  },
  setCarrier(state, value) {
    state.carrier = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};